"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "abLogo", {
  enumerable: true,
  get: function get() {
    return _abLogo["default"];
  }
});
Object.defineProperty(exports, "arrow", {
  enumerable: true,
  get: function get() {
    return _arrow["default"];
  }
});
Object.defineProperty(exports, "bcaLogo", {
  enumerable: true,
  get: function get() {
    return _bcaLogo["default"];
  }
});
Object.defineProperty(exports, "bcomLogo", {
  enumerable: true,
  get: function get() {
    return _bcomLogo["default"];
  }
});
Object.defineProperty(exports, "blinds", {
  enumerable: true,
  get: function get() {
    return _blinds["default"];
  }
});
Object.defineProperty(exports, "bulkPriceElligible", {
  enumerable: true,
  get: function get() {
    return _bulkPriceElligible["default"];
  }
});
Object.defineProperty(exports, "caret", {
  enumerable: true,
  get: function get() {
    return _caret["default"];
  }
});
Object.defineProperty(exports, "ccAmex", {
  enumerable: true,
  get: function get() {
    return _ccAmex["default"];
  }
});
Object.defineProperty(exports, "ccDiscover", {
  enumerable: true,
  get: function get() {
    return _ccDiscover["default"];
  }
});
Object.defineProperty(exports, "ccHdCard", {
  enumerable: true,
  get: function get() {
    return _ccHdCard["default"];
  }
});
Object.defineProperty(exports, "ccHdCommercial", {
  enumerable: true,
  get: function get() {
    return _ccHdCommercial["default"];
  }
});
Object.defineProperty(exports, "ccHdConsumer", {
  enumerable: true,
  get: function get() {
    return _ccHdConsumer["default"];
  }
});
Object.defineProperty(exports, "ccHdPro", {
  enumerable: true,
  get: function get() {
    return _ccHdProx["default"];
  }
});
Object.defineProperty(exports, "ccHdProPurchase", {
  enumerable: true,
  get: function get() {
    return _ccHdPro["default"];
  }
});
Object.defineProperty(exports, "ccMastercard", {
  enumerable: true,
  get: function get() {
    return _ccMastercard["default"];
  }
});
Object.defineProperty(exports, "ccVisa", {
  enumerable: true,
  get: function get() {
    return _ccVisa["default"];
  }
});
Object.defineProperty(exports, "checkOutline", {
  enumerable: true,
  get: function get() {
    return _checkOutline["default"];
  }
});
exports["default"] = void 0;
Object.defineProperty(exports, "delivery", {
  enumerable: true,
  get: function get() {
    return _delivery["default"];
  }
});
Object.defineProperty(exports, "download", {
  enumerable: true,
  get: function get() {
    return _download["default"];
  }
});
Object.defineProperty(exports, "drag", {
  enumerable: true,
  get: function get() {
    return _drag["default"];
  }
});
Object.defineProperty(exports, "drill", {
  enumerable: true,
  get: function get() {
    return _drill["default"];
  }
});
Object.defineProperty(exports, "exclamation", {
  enumerable: true,
  get: function get() {
    return _exclamationBox["default"];
  }
});
Object.defineProperty(exports, "exclamationTriangle", {
  enumerable: true,
  get: function get() {
    return _exclamationTriangle["default"];
  }
});
Object.defineProperty(exports, "footerBcomBlog", {
  enumerable: true,
  get: function get() {
    return _footerBcomBlog["default"];
  }
});
Object.defineProperty(exports, "footerFacebook", {
  enumerable: true,
  get: function get() {
    return _footerFacebook["default"];
  }
});
Object.defineProperty(exports, "footerHouzz", {
  enumerable: true,
  get: function get() {
    return _footerHouzz["default"];
  }
});
Object.defineProperty(exports, "footerInstagram", {
  enumerable: true,
  get: function get() {
    return _footerInstagram["default"];
  }
});
Object.defineProperty(exports, "footerPinterest", {
  enumerable: true,
  get: function get() {
    return _footerPinterest["default"];
  }
});
Object.defineProperty(exports, "footerTwitter", {
  enumerable: true,
  get: function get() {
    return _footerTwitter["default"];
  }
});
Object.defineProperty(exports, "footerYouTube", {
  enumerable: true,
  get: function get() {
    return _footerYoutube["default"];
  }
});
Object.defineProperty(exports, "guaranteedToFit", {
  enumerable: true,
  get: function get() {
    return _guaranteedToFit["default"];
  }
});
Object.defineProperty(exports, "hdShipToHome", {
  enumerable: true,
  get: function get() {
    return _hdShipToHome["default"];
  }
});
Object.defineProperty(exports, "home", {
  enumerable: true,
  get: function get() {
    return _home["default"];
  }
});
Object.defineProperty(exports, "image", {
  enumerable: true,
  get: function get() {
    return _image["default"];
  }
});
Object.defineProperty(exports, "info", {
  enumerable: true,
  get: function get() {
    return _info["default"];
  }
});
Object.defineProperty(exports, "jbLogo", {
  enumerable: true,
  get: function get() {
    return _jbLogo["default"];
  }
});
Object.defineProperty(exports, "loadingLogo", {
  enumerable: true,
  get: function get() {
    return _loadingLogo["default"];
  }
});
Object.defineProperty(exports, "newLowerPrice", {
  enumerable: true,
  get: function get() {
    return _newLowerPrice["default"];
  }
});
Object.defineProperty(exports, "noShipToHome", {
  enumerable: true,
  get: function get() {
    return _noShipToHome["default"];
  }
});
Object.defineProperty(exports, "noShipToStore", {
  enumerable: true,
  get: function get() {
    return _noShipToStore["default"];
  }
});
Object.defineProperty(exports, "overStock", {
  enumerable: true,
  get: function get() {
    return _overStock["default"];
  }
});
Object.defineProperty(exports, "shipping", {
  enumerable: true,
  get: function get() {
    return _shipping["default"];
  }
});
Object.defineProperty(exports, "shippingAlt", {
  enumerable: true,
  get: function get() {
    return _shippingAlt["default"];
  }
});
Object.defineProperty(exports, "shippingSamples", {
  enumerable: true,
  get: function get() {
    return _shippingSamples["default"];
  }
});
Object.defineProperty(exports, "specialBuy", {
  enumerable: true,
  get: function get() {
    return _specialBuy["default"];
  }
});
Object.defineProperty(exports, "store", {
  enumerable: true,
  get: function get() {
    return _store["default"];
  }
});
Object.defineProperty(exports, "storeAlt", {
  enumerable: true,
  get: function get() {
    return _storeAlt["default"];
  }
});
Object.defineProperty(exports, "swatches", {
  enumerable: true,
  get: function get() {
    return _swatches["default"];
  }
});
Object.defineProperty(exports, "tapeMeasure", {
  enumerable: true,
  get: function get() {
    return _tapeMeasure["default"];
  }
});
Object.defineProperty(exports, "telephone", {
  enumerable: true,
  get: function get() {
    return _telephone["default"];
  }
});
Object.defineProperty(exports, "thdLogo", {
  enumerable: true,
  get: function get() {
    return _thdLogo["default"];
  }
});
Object.defineProperty(exports, "thdPhone", {
  enumerable: true,
  get: function get() {
    return _thdPhone["default"];
  }
});
Object.defineProperty(exports, "tools", {
  enumerable: true,
  get: function get() {
    return _tools["default"];
  }
});
Object.defineProperty(exports, "videoLibrary", {
  enumerable: true,
  get: function get() {
    return _videoLibrary["default"];
  }
});

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _svgInlineReact = _interopRequireDefault(require("svg-inline-react"));

var _abLogo = _interopRequireDefault(require("./ab-logo"));

var _arrow = _interopRequireDefault(require("./arrow"));

var _bcaLogo = _interopRequireDefault(require("./bca-logo"));

var _bcomLogo = _interopRequireDefault(require("./bcom-logo"));

var _blinds = _interopRequireDefault(require("./blinds"));

var _bulkPriceElligible = _interopRequireDefault(require("./bulk-price-elligible"));

var _caret = _interopRequireDefault(require("./caret"));

var _ccAmex = _interopRequireDefault(require("./cc-amex"));

var _ccDiscover = _interopRequireDefault(require("./cc-discover"));

var _ccHdCard = _interopRequireDefault(require("./cc-hd-card"));

var _ccHdCommercial = _interopRequireDefault(require("./cc-hd-commercial"));

var _ccHdConsumer = _interopRequireDefault(require("./cc-hd-consumer"));

var _ccHdPro = _interopRequireDefault(require("./cc-hd-pro"));

var _ccHdProx = _interopRequireDefault(require("./cc-hd-prox"));

var _ccMastercard = _interopRequireDefault(require("./cc-mastercard"));

var _ccVisa = _interopRequireDefault(require("./cc-visa"));

var _checkOutline = _interopRequireDefault(require("./check-outline"));

var _delivery = _interopRequireDefault(require("./delivery"));

var _download = _interopRequireDefault(require("./download"));

var _drag = _interopRequireDefault(require("./drag"));

var _drill = _interopRequireDefault(require("./drill"));

var _exclamationBox = _interopRequireDefault(require("./exclamation-box"));

var _exclamationTriangle = _interopRequireDefault(require("./exclamationTriangle"));

var _footerBcomBlog = _interopRequireDefault(require("./footer-bcom-blog"));

var _footerFacebook = _interopRequireDefault(require("./footer-facebook"));

var _footerHouzz = _interopRequireDefault(require("./footer-houzz"));

var _footerInstagram = _interopRequireDefault(require("./footer-instagram"));

var _footerPinterest = _interopRequireDefault(require("./footer-pinterest"));

var _footerTwitter = _interopRequireDefault(require("./footer-twitter"));

var _footerYoutube = _interopRequireDefault(require("./footer-youtube"));

var _guaranteedToFit = _interopRequireDefault(require("./guaranteed-to-fit"));

var _hdShipToHome = _interopRequireDefault(require("./hd-ship-to-home"));

var _home = _interopRequireDefault(require("./home"));

var _image = _interopRequireDefault(require("./image"));

var _info = _interopRequireDefault(require("./info"));

var _installationServices = _interopRequireDefault(require("./installation-services"));

var _jbLogo = _interopRequireDefault(require("./jb-logo"));

var _loadingLogo = _interopRequireDefault(require("./loading-logo"));

var _newLowerPrice = _interopRequireDefault(require("./new-lower-price"));

var _noShipToHome = _interopRequireDefault(require("./no-ship-to-home"));

var _noShipToStore = _interopRequireDefault(require("./no-ship-to-store"));

var _overStock = _interopRequireDefault(require("./over-stock"));

var _shipping = _interopRequireDefault(require("./shipping"));

var _shippingAlt = _interopRequireDefault(require("./shipping-alt"));

var _shippingSamples = _interopRequireDefault(require("./shipping-samples"));

var _specialBuy = _interopRequireDefault(require("./special-buy"));

var _store = _interopRequireDefault(require("./store"));

var _storeAlt = _interopRequireDefault(require("./store-alt"));

var _swatches = _interopRequireDefault(require("./swatches"));

var _tapeMeasure = _interopRequireDefault(require("./tape-measure"));

var _telephone = _interopRequireDefault(require("./telephone"));

var _thdLogo = _interopRequireDefault(require("./thd-logo"));

var _thdPhone = _interopRequireDefault(require("./thd-phone"));

var _tools = _interopRequireDefault(require("./tools"));

var _videoLibrary = _interopRequireDefault(require("./video-library"));

var _excluded = ["name", "returnAs"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var svgToMiniDataURI = require('mini-svg-data-uri');

var vectors = {
  'ab-logo': _abLogo["default"],
  'bca-logo': _bcaLogo["default"],
  'bcom-logo': _bcomLogo["default"],
  'bulk-price-elligible': _bulkPriceElligible["default"],
  'cc-amex': _ccAmex["default"],
  'cc-discover': _ccDiscover["default"],
  'cc-hd-card': _ccHdCard["default"],
  'cc-hd-commercial': _ccHdCommercial["default"],
  'cc-hd-consumer': _ccHdConsumer["default"],
  'cc-hd-pro': _ccHdPro["default"],
  'cc-hd-prox': _ccHdProx["default"],
  'cc-mastercard': _ccMastercard["default"],
  'cc-visa': _ccVisa["default"],
  'check-outline': _checkOutline["default"],
  'exclamation-box': _exclamationBox["default"],
  'exclamation-triangle': _exclamationTriangle["default"],
  'footer-bcom-blog': _footerBcomBlog["default"],
  'footer-facebook': _footerFacebook["default"],
  'footer-houzz': _footerHouzz["default"],
  'footer-instagram': _footerInstagram["default"],
  'footer-pinterest': _footerPinterest["default"],
  'footer-twitter': _footerTwitter["default"],
  'footer-youtube': _footerYoutube["default"],
  'guaranteed-to-fit': _guaranteedToFit["default"],
  'hd-ship-to-home': _hdShipToHome["default"],
  'installation-services': _installationServices["default"],
  'jb-logo': _jbLogo["default"],
  'loading-logo': _loadingLogo["default"],
  'new-lower-price': _newLowerPrice["default"],
  'no-ship-to-home': _noShipToHome["default"],
  'no-ship-to-store': _noShipToStore["default"],
  'over-stock': _overStock["default"],
  'shipping-alt': _shippingAlt["default"],
  'shipping-samples': _shippingSamples["default"],
  'special-buy': _specialBuy["default"],
  'store-alt': _storeAlt["default"],
  'tape-measure': _tapeMeasure["default"],
  'thd-logo': _thdLogo["default"],
  'thd-phone': _thdPhone["default"],
  'video-library': _videoLibrary["default"],
  arrow: _arrow["default"],
  blinds: _blinds["default"],
  caret: _caret["default"],
  delivery: _delivery["default"],
  download: _download["default"],
  drag: _drag["default"],
  drill: _drill["default"],
  exclamation: _exclamationBox["default"],
  home: _home["default"],
  image: _image["default"],
  info: _info["default"],
  shipping: _shipping["default"],
  store: _store["default"],
  swatches: _swatches["default"],
  telephone: _telephone["default"],
  tools: _tools["default"]
};

var Vector = function Vector(_ref) {
  var name = _ref.name,
      returnAs = _ref.returnAs,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(undefined),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      svg = _useState2[0],
      setSvg = _useState2[1];

  (0, _react.useEffect)(function () {
    (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var Svg;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              try {
                Svg = vectors[name.toLowerCase()];
                setSvg(Svg(_objectSpread({}, props)));
              } catch (error) {
                // eslint-disable-next-line no-console
                console.error("SVG \"".concat(name, "\" was not found."), error);
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [name, props]);

  if (returnAs === 'string') {
    return svg;
  }

  if (returnAs === 'data-uri') {
    return svg && svgToMiniDataURI(svg);
  }

  return /*#__PURE__*/_react["default"].createElement(_svgInlineReact["default"], {
    src: svg
  });
};

Vector.defaultProps = {
  returnAs: 'object'
};
Vector.propTypes = {
  name: _propTypes.string.isRequired,
  returnAs: (0, _propTypes.oneOf)(['data-uri', 'object', 'string'])
};
Vector.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Vector",
  "props": {
    "returnAs": {
      "defaultValue": {
        "value": "'object'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'data-uri'",
          "computed": false
        }, {
          "value": "'object'",
          "computed": false
        }, {
          "value": "'string'",
          "computed": false
        }]
      },
      "required": false
    },
    "name": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = Vector;
exports["default"] = _default;